module.exports = __webpack_public_path__ + "img/2.52b4f423.jpg";